import { Layout } from "antd";
import styled from "styled-components";

const { Content } = Layout;

export const Container = styled(Content)`
  margin: 24px;
  padding: 24px;
  background: #fff;
`;

export const TileContainer = styled(Content)`
  padding: 24px;
  background: #fff;
`;
